import { z } from 'zod';

import { exploreColumnSchema } from './explore-column';

export type UpdatePresetPayload = z.output<typeof updatePresetPayloadSchema>;
export type UpdatePresetPayloadDTO = z.input<typeof updatePresetPayloadSchema>;

export const updatePresetPayloadSchema = z.object({
  columns: z.array(exploreColumnSchema).min(1).optional(),
  name: z.string().optional(),
});
